import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import "./ContactPopup.css";

export default function ContactPopup({ isOpen, onClose }) {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: ""
  });

  function handleChange(e) {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  }

  function handleSubmit(e) {
    e.preventDefault();

    emailjs.send(
      "service_1qs5a3f",          // Your Service ID
      "template_vfgthui",        // Your Template ID
      {
        name: formData.name,
        email: formData.email,
        message: formData.message
      },
      "YOUR_PUBLIC_KEY_HERE"     // Your Public Key
    )
    .then(() => {
      alert("Message sent!");
      onClose();
    })
    .catch((err) => {
      console.error("EmailJS error:", err);
      alert("Something went wrong.");
    });
  }

  if (!isOpen) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-box">
        <button className="popup-close" onClick={onClose}>×</button>

        <h2>Contact Us</h2>

        <form onSubmit={handleSubmit} className="popup-form">
          <label>Name</label>
          <input
            type="text"
            name="name"
            placeholder="Your name..."
            value={formData.name}
            onChange={handleChange}
            required
          />

          <label>Email</label>
          <input
            type="email"
            name="email"
            placeholder="Your email..."
            value={formData.email}
            onChange={handleChange}
            required
          />

          <label>Message</label>
          <textarea
            name="message"
            placeholder="Write your message..."
            value={formData.message}
            onChange={handleChange}
            required
          />

          <button type="submit" className="popup-send">Send</button>
        </form>
      </div>
    </div>
  );
}
